<div class="popup" *ngIf="viewModel">
  <ng-template ngFor let-item [ngForOf]="viewModel.list">
    <p [innerHtml]="item.message"></p>
    <p-fieldset legend="Dettagli" *ngIf="item.detail" [toggleable]="true" [collapsed]="true">
      <p [innerHtml]="item.detail"></p>
    </p-fieldset>
  </ng-template>
</div>
